'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../utils/getThemeProp.js');
require('../utils/colors.js');
require('../utils/dates.js');
require('../utils/numbers.js');
require('../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../utils/strings.js');
require('../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../utils/safeFetch.js');
require('../utils/dom.js');

var BulletSpan = styled__default.span(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  padding-left: 0.58rem;\n  color: ", ";\n  &.active {\n    color: ", ";\n  }\n"], ["\n  padding-left: 0.58rem;\n  color: ", ";\n  &.active {\n    color: ", ";\n  }\n"])), getThemeProp('palette.text.secondary'), getThemeProp('palette.text.primary'));
var SubListContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  .MuiTypography-root {\n    font-family: ", ";\n    font-size: 13px;\n    color: ", ";\n  }\n  .MuiListItemIcon-root {\n    min-width: 0;\n    padding-right: 1.5rem;\n  }\n  &.active {\n    background-color: ", ";\n    .MuiTypography-root {\n      color: ", ";\n      font-weight: 600;\n    }\n  }\n"], ["\n  .MuiTypography-root {\n    font-family: ", ";\n    font-size: 13px;\n    color: ", ";\n  }\n  .MuiListItemIcon-root {\n    min-width: 0;\n    padding-right: 1.5rem;\n  }\n  &.active {\n    background-color: ", ";\n    .MuiTypography-root {\n      color: ", ";\n      font-weight: 600;\n    }\n  }\n"])), getThemeProp('typography.fontFamily', 'sans-serif'), getThemeProp('palette.text.secondary'), getThemeProp('palette.background.default'), getThemeProp('palette.text.primary'));
var templateObject_1, templateObject_2;

exports.BulletSpan = BulletSpan;
exports.SubListContainer = SubListContainer;
